import { Listbox } from '@headlessui/react'
import PropTypes from 'prop-types'
import { cn } from '../modules'

function SelectItem({
  value,
  disabled,
  label,
}) {
  return (
    <Listbox.Option
      value={value}
      disabled={disabled}
      className={({ active, selected }) => cn(
        active ? 'bg-gray-50' : 'bg-none',
        selected && 'font-medium text-theme-600',
        'h-10 flex items-center cursor-pointer pl-3 text-base',
      )}
    >
      {label}
    </Listbox.Option>
  )
}

SelectItem.propTypes = {
  value: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
}

SelectItem.defaultProps = {
  disabled: false,
}

export default SelectItem
